module.exports = __webpack_public_path__ + "img/m-yinjianshenqing.b2f1bee5.svg";